// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.applications.RentalManagerUserApplicationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetApplicationConfigurationForListingResponseWebDto,
  GetApplicationPermissionsForListingResponseWebDto,
  ListingAlias,
} from '../..';

interface GetApplicationConfigurationForListingParams {
  listingAlias: ListingAlias;
}
interface GetApplicationPermissionsForListingParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserApplicationsWebApiHandler_enableApplications_Path =
  '/api/web/v1/users/applications/enableApplications';

/**
 * Enable applications for the user
 */
export const RentalManagerUserApplicationsWebApiHandler_enableApplications = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserApplicationsWebApiHandler_enableApplications_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserApplicationsWebApiHandler_getApplicationConfigurationForListing_Path =
  '/api/web/v1/users/applications/getApplicationConfigurationForListing';

/**
 * Get the application configuration assigned to a listing, if any
 */
export const RentalManagerUserApplicationsWebApiHandler_getApplicationConfigurationForListing = (
  getParams: GetApplicationConfigurationForListingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetApplicationConfigurationForListingParams,
    never,
    GetApplicationConfigurationForListingResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserApplicationsWebApiHandler_getApplicationConfigurationForListing_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_Path =
  '/api/web/v1/users/applications/getApplicationPermissionsForListing';

/**
 * Checks if the logged in user can view and manage rental applications for a listing
 */
export const RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing = (
  getParams: GetApplicationPermissionsForListingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetApplicationPermissionsForListingParams,
    never,
    GetApplicationPermissionsForListingResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserApplicationsWebApiHandler_getApplicationPermissionsForListing_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
